import { Button, Divider, Flex, Select } from 'antd';
import React, { useState } from 'react';
import { DAYS } from 'constants';
import dayjs from 'dayjs';
import dayjsDuration from 'dayjs/plugin/duration';
import WorkingDayInput from './WorkingDayInput';

dayjs.extend(dayjsDuration);

function CopyHoursBar({ value, onChange }) {
  const [selectedDay, setSelectedDay] = useState(null);

  const handleCopyToAllDays = () => {
    if (!selectedDay) return;
    const source = value[selectedDay] ?? { hours: [[null, null]], isClosed: false };
    const newValue = {};
    Object.keys(DAYS).forEach((day) => {
      newValue[day] = {
        isClosed: source.isClosed,
        hours: (source.hours ?? [[null, null]]).map(([start, end]) => [
          start ? (dayjs.isDayjs(start) ? start.clone() : dayjs(start)) : null,
          end ? (dayjs.isDayjs(end) ? end.clone() : dayjs(end)) : null,
        ]),
      };
    });
    onChange(newValue);
  };

  return (
    <Flex wrap="wrap" gap="small" align="center">
      <Select
        placeholder="Select day to copy from"
        value={selectedDay}
        onChange={setSelectedDay}
        style={{ minWidth: 180 }}
        options={Object.entries(DAYS).map(([key, label]) => ({ value: key, label }))}
      />
      <Button type="primary" onClick={handleCopyToAllDays} disabled={!selectedDay}>
        Copy to all days
      </Button>
    </Flex>
  );
}

function ActiveHoursInput({ value = {}, onChange }) {
  return (
    <Flex vertical gap="middle">
      <CopyHoursBar value={value} onChange={onChange} />
      {Object.entries(DAYS).map(([key, title], index) => (
        <React.Fragment key={key}>
          <WorkingDayInput
            title={title}
            onChange={(v) => onChange({ ...value, [key]: v })}
            value={value[key]}
          />
          {index < Object.keys(DAYS).length - 1 && <Divider style={{ margin: 0 }} />}
        </React.Fragment>
      ))}
    </Flex>
  );
}

ActiveHoursInput.serialize = (activeHours) => Object.entries(activeHours || {})
  .flatMap(([weekday, { hours, isClosed }]) => (isClosed ? null : (hours || [])
    .filter(([start, end]) => start && end)
    .map(([start, end]) => ({
      weekday,
      from_hour: start.format('HH:mm:ss'),
      duration: dayjs.duration(end.diff(start)).format('HH:mm:ss'),
    }))))
  .filter(Boolean);

ActiveHoursInput.deserialize = (activeTimes) => Object.keys(DAYS)
  .reduce((acc, day) => {
    const hours = (activeTimes || [])
      .filter((a) => a.weekday === day)
      .sort(({ from_hour: a }, { from_hour: b }) => dayjs(a, 'HH:mm:ss').valueOf() - dayjs(b, 'HH:mm:ss').valueOf())
      .map(({ from_hour, duration }) => {
        const [h, m, s] = duration.split(':');
        return [
          dayjs(from_hour, 'HH:mm:ss'),
          dayjs(from_hour, 'HH:mm:ss').add(dayjs.duration({
            seconds: s,
            minutes: m,
            hours: h,
          })),
        ];
      });
    return {
      ...acc,
      [day]: {
        isClosed: hours.length === 0,
        hours: hours.length ? hours : [[null, null]],
      },
    };
  }, {});
export default ActiveHoursInput;
